define(['../../lead/services/leads'], function () {
    'use strict';

    return {
        name: 'navigationCtrl',
        arguments: [
            '$rootScope',
            '$scope',
            '$state',
            'Announcements',
            'Leads',
            'Profile',
            'Site',
            function (
                $rootScope,
                $scope,
                $state,
                Announcements,
                Leads,
                Profile,
                Site
            ) {
                $scope.announcements = Announcements.get();
                $scope.state = $state;
                $scope.leadCounts = Leads.getLeadCounts();
                $scope.site = Site.getSite();
                $scope.sites = Site.getAllSites();
                $scope.user = Profile.getProfile();
                $scope.$on('user-updated', function () {
                    $scope.user = Profile.getProfile();
                });
                $scope.logoLink = $rootScope.Routing.generate(
                    'settings_microsite_site'
                );
                $scope.logoTarget = null;
                $scope.$watch('site.domain', function (newValue, oldValue) {
                    if (newValue && newValue != oldValue) {
                        var domain = newValue;
                        Profile.checkDomain(domain).$promise.then(function (
                            domainCheck
                        ) {
                            if (
                                typeof domainCheck.domainCorrect == 'boolean' &&
                                domainCheck.domainCorrect == true
                            ) {
                                $scope.logoLink = 'http://' + domain;
                                $scope.logoTarget = '_blank';
                            } else {
                                $scope.logoLink = $rootScope.Routing.generate(
                                    'settings_microsite_site'
                                );
                                $scope.logoTarget = null;
                            }
                        });
                    }
                });

                $scope.closeAnnouncement = function () {
                    Announcements.close();
                };

                $scope.newSite = false;
                $scope.openAddSite = function () {
                    $scope.newSite = {};
                    $scope.$broadcast('onboardingWrapperShown');
                };
                $scope.$on('openAddSite', function () {
                    $scope.openAddSite();
                });
                $scope.closeAddSite = function () {
                    $scope.newSite = false;
                    $scope.$broadcast('onboardingWrapperHidden');
                };
                $scope.submitNewSiteForm = function (e, form) {
                    e.preventDefault();

                    form.$submitted = true;
                    if (form.$valid) {
                        console.log('is valid');
                    }
                };

                $scope.themeNames = {};
                $scope.$watch('newSite.theme', function (newValue, oldValue) {
                    if (newValue != oldValue) {
                        $scope.sites.$promise.then(function (sites) {
                            var count = 0;
                            angular.forEach(sites, function (site) {
                                if (
                                    site.hasOwnProperty('theme') &&
                                    site.theme.id == newValue
                                ) {
                                    count++;
                                }
                            });

                            $scope.newSite.name =
                                'My ' + $scope.themeNames[newValue];

                            if (count > 0) {
                                $scope.newSite.name += ' ' + (count + 1);
                            }
                        });
                    }
                });

                $scope.saveSite = function (site) {
                    site.save(function () {
                        Site.getAllSites(true);
                    });
                };
            },
        ],
    };
});
